import { api } from './emptyApi'

export const addTagTypes = ['Assistant'] as const
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: (build) => ({
      createConversation: build.mutation<CreateConversationResponse, CreateConversationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/conversations`,
          method: 'POST',
          body: queryArg.conversationCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Assistant']
      }),
      listConversations: build.query<ListConversationsResponse, ListConversationsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/conversations`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['Assistant']
      }),
      getConversation: build.query<GetConversationResponse, GetConversationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/conversations/${queryArg.conversationId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Assistant']
      }),
      updateConversation: build.mutation<UpdateConversationResponse, UpdateConversationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/conversations/${queryArg.conversationId}`,
          method: 'PATCH',
          body: queryArg.conversationUpdateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Assistant']
      }),
      deleteConversation: build.mutation<DeleteConversationResponse, DeleteConversationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/conversations/${queryArg.conversationId}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Assistant']
      }),
      shareConversation: build.mutation<ShareConversationResponse, ShareConversationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/conversations/${queryArg.conversationId}/share`,
          method: 'POST',
          body: queryArg.conversationShareParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Assistant']
      }),
      sendMessage: build.mutation<SendMessageResponse, SendMessageArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/conversations/${queryArg.conversationId}/messages`,
          method: 'POST',
          body: queryArg.chatTurnRequest,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Assistant']
      }),
      createAttachment: build.mutation<CreateAttachmentResponse, CreateAttachmentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/conversations/${queryArg.conversationId}/attachments`,
          method: 'POST',
          body: queryArg.attachmentCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Assistant']
      }),
      setMessageFeedback: build.mutation<SetMessageFeedbackResponse, SetMessageFeedbackArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/conversations/${queryArg.conversationId}/messages/${queryArg.messageId}/feedback`,
          method: 'POST',
          body: queryArg.messageFeedbackParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Assistant']
      }),
      getAction: build.query<GetActionResponse, GetActionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/actions/${queryArg.actionId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Assistant']
      }),
      dispatchAction: build.mutation<DispatchActionResponse, DispatchActionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/actions/${queryArg.actionId}/dispatch`,
          method: 'POST',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Assistant']
      }),
      getActionArtifact: build.query<GetActionArtifactResponse, GetActionArtifactArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/actions/${queryArg.actionId}/artifact`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Assistant']
      }),
      getActionArtifactLink: build.query<GetActionArtifactLinkResponse, GetActionArtifactLinkArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/actions/${queryArg.actionId}/artifact-link`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Assistant']
      }),
      rejectAction: build.mutation<RejectActionResponse, RejectActionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assistant/actions/${queryArg.actionId}/reject`,
          method: 'POST',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Assistant']
      }),
      refreshDashboard: build.mutation<RefreshDashboardResponse, RefreshDashboardArgs>({
        query: (queryArg) => ({
          url: `/api/v1/generative-dashboard/refresh`,
          method: 'POST',
          body: queryArg.dashboardRefreshParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Assistant']
      }),
      createDashboardSave: build.mutation<CreateDashboardSaveResponse, CreateDashboardSaveArgs>({
        query: (queryArg) => ({
          url: `/api/v1/generative-dashboard/saves`,
          method: 'POST',
          body: queryArg.dashboardSaveCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Assistant']
      }),
      listDashboardSaves: build.query<ListDashboardSavesResponse, ListDashboardSavesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/generative-dashboard/saves`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['Assistant']
      }),
      getDashboardSave: build.query<GetDashboardSaveResponse, GetDashboardSaveArgs>({
        query: (queryArg) => ({
          url: `/api/v1/generative-dashboard/saves/${queryArg.saveId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Assistant']
      }),
      deleteDashboardSave: build.mutation<DeleteDashboardSaveResponse, DeleteDashboardSaveArgs>({
        query: (queryArg) => ({
          url: `/api/v1/generative-dashboard/saves/${queryArg.saveId}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Assistant']
      })
    }),
    overrideExisting: false
  })
export { injectedRtkApi as enhancedApi }
export type CreateConversationResponse = /** status 201 Successful Response */ Conversation
export type CreateConversationArgs = {
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  conversationCreateParams: ConversationCreateParams
}
export type ListConversationsResponse = /** status 200 Successful Response */ CursorPagedListConversation
export type ListConversationsArgs = {
  limit?: number
  startingAfter?: string | null
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type GetConversationResponse = /** status 200 Successful Response */ ConversationDetail
export type GetConversationArgs = {
  conversationId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type UpdateConversationResponse = /** status 200 Successful Response */ Conversation
export type UpdateConversationArgs = {
  conversationId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  conversationUpdateParams: ConversationUpdateParams
}
export type DeleteConversationResponse = unknown
export type DeleteConversationArgs = {
  conversationId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type ShareConversationResponse = /** status 200 Successful Response */ Conversation
export type ShareConversationArgs = {
  conversationId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  conversationShareParams: ConversationShareParams
}
export type SendMessageResponse =
  /** status 200 AI SDK v6 UI message stream; the `x-vercel-ai-ui-message-stream: v1` header marks the protocol. The request body is what `useChat` sends: `id`, `trigger: submit-message`, `messages` (only the last, the new user message, is read) and optionally `contextRefs`, `pageContext` and `autoApprove`. A file part of the user message references an attachment of the conversation by its `url` (see `POST /assistant/conversations/{conversationId}/attachments`). */ ChatChunk
export type SendMessageArgs = {
  conversationId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  chatTurnRequest: ChatTurnRequest
}
export type CreateAttachmentResponse = /** status 201 Successful Response */ AttachmentUpload
export type CreateAttachmentArgs = {
  conversationId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  attachmentCreateParams: AttachmentCreateParams
}
export type SetMessageFeedbackResponse = /** status 200 Successful Response */ MessageFeedback
export type SetMessageFeedbackArgs = {
  conversationId: string
  messageId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  messageFeedbackParams: MessageFeedbackParams
}
export type GetActionResponse = /** status 200 Successful Response */ Action
export type GetActionArgs = {
  actionId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type DispatchActionResponse = /** status 202 Successful Response */ ActionDispatch
export type DispatchActionArgs = {
  actionId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type GetActionArtifactResponse = unknown
export type GetActionArtifactArgs = {
  actionId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type GetActionArtifactLinkResponse = /** status 200 Successful Response */ ArtifactLink
export type GetActionArtifactLinkArgs = {
  actionId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type RejectActionResponse = /** status 200 Successful Response */ Action
export type RejectActionArgs = {
  actionId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type RefreshDashboardResponse =
  /** status 200 Server-sent events: `layout` (`tiles` as loading placeholders), one `panel` per refreshed tile as it resolves, then `done`; `warning` names skipped tiles and `error` ends a refresh that could not run. */ DashboardRefreshEvent
export type RefreshDashboardArgs = {
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  dashboardRefreshParams: DashboardRefreshParams
}
export type CreateDashboardSaveResponse = /** status 201 Successful Response */ DashboardSave
export type CreateDashboardSaveArgs = {
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  dashboardSaveCreateParams: DashboardSaveCreateParams
}
export type ListDashboardSavesResponse = /** status 200 Successful Response */ CursorPagedListDashboardSave
export type ListDashboardSavesArgs = {
  limit?: number
  startingAfter?: string | null
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type GetDashboardSaveResponse = /** status 200 Successful Response */ DashboardSave
export type GetDashboardSaveArgs = {
  saveId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type DeleteDashboardSaveResponse = unknown
export type DeleteDashboardSaveArgs = {
  saveId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type PlaybookId =
  | 'builtin:billing-composer'
  | 'builtin:charger-diagnosis'
  | 'builtin:charger-offline-triage'
  | 'builtin:daily-fault-report'
  | 'builtin:depot-health-check'
  | 'builtin:generate-dashboard'
  | 'builtin:network-health-check'
  | 'builtin:ticket-delegation'
export type Conversation = {
  id: string
  shareScope: string
  createdByUserId: string
  title?: string | null
  status: string
  createdAt: string
  updatedAt: string
  lastMessageAt?: string | null
  /** The built-in skill every turn of the conversation starts with loaded. */
  playbook?: PlaybookId | null
}
export type ValidationError = {
  loc: (string | number)[]
  msg: string
  type: string
  ctx?: object
}
export type HttpValidationError = {
  detail?: ValidationError[]
}
export type ConversationCreateParams = {
  title?: string | null
  /** personal (default) or organization. Use organization for ticket-linked conversations so other organization members can read them. */
  shareScope?: string | null
  /** A built-in skill id. Every turn of the conversation starts with it loaded: its instructions lead the turn's context and its tools are the turn's allowlist. Fixed for the life of the conversation. */
  playbook?: PlaybookId | null
}
export type CursorLinks = {
  current?: string | null
  next?: string | null
  prev?: string | null
}
export type CursorMeta = {
  total?: number | null
  pageSize?: number | null
  last?: boolean | null
}
export type CursorPagedListConversation = {
  data: Conversation[]
  links: CursorLinks
  meta: CursorMeta
}
export type TimingSpan = {
  startedAt: string
  endedAt?: string | null
}
export type MessageTiming = {
  startedAt: string
  endedAt?: string | null
  reasoning: TimingSpan[]
  tools: {
    [key: string]: TimingSpan
  }
}
export type AssistantMessageMetadata = {
  timing?: MessageTiming | null
  /** The owner's rating of the message: up or down. */
  feedbackRating?: string | null
}
export type StoredUiMessage = {
  id: string
  role: string
  parts: {
    [key: string]: unknown
  }[]
  metadata?: AssistantMessageMetadata | null
}
export type Action = {
  id: string
  type: string
  status: string
  longRunning: boolean
  outputSummary?: string | null
  errorMessage?: string | null
  progressPhase?: string | null
  progressDetail?: string | null
  progressSubstatus?: string | null
  artifactKey?: string | null
  createdAt: string
  updatedAt: string
}
export type Quota = {
  used: number
  limit: number
  remaining: number
}
export type ConversationDetail = {
  conversation: Conversation
  messages: StoredUiMessage[]
  actions: Action[]
  quota: Quota
  /** True when the viewer can read but not send messages (organization-shared, not the owner). */
  readOnly: boolean
}
export type ConversationUpdateParams = {
  title: string
}
export type ConversationShareParams = {
  shareScope: string
}
export type ChatChunk = {
  /** Chunk type, for example `text-delta`. */
  type: string
}
export type ContextRef = {
  type?: string | null
  id?: string | null
  label?: string | null
  name?: string | null
  make?: string | null
  model?: string | null
}
export type ViewedEntityType =
  | 'charger'
  | 'site'
  | 'vehicle'
  | 'ticket'
  | 'organization'
  | 'user'
  | 'fleet'
  | 'user_group'
  | 'product'
  | 'agreement'
  | 'invoice'
  | 'payout'
  | 'transaction'
  | 'battery'
  | 'generator'
  | 'load'
  | 'panel'
  | 'fuel_tank'
  | 'solar_array'
  | 'grid_connection'
  | 'meter'
  | 'link'
  | 'tariff'
  | 'project'
  | 'plan'
  | 'workflow'
export type ViewedEntity = {
  type: ViewedEntityType
  id: string
  name?: string | null
}
export type PageContext = {
  route?: string | null
  pageTitle?: string | null
  entities?: ViewedEntity[]
}
export type ChatTurnRequest = {
  contextRefs?: ContextRef[]
  pageContext?: PageContext | null
  autoApprove?: boolean
  id: string
  trigger: string
  messageId?: string | null
  messages: {
    [key: string]: unknown
  }[]
}
export type AttachmentUpload = {
  attachmentId: string
  filename: string
  contentType: string
  sizeBytes: number
  createdAt: string
  /** The file part URL that references this attachment. */
  url: string
  uploadUrl: string
  uploadHeaders: {
    [key: string]: string
  }
  uploadExpiresAt: string
}
export type AttachmentCreateParams = {
  filename: string
  contentType?: string | null
  sizeBytes: number
}
export type MessageFeedback = {
  messageId: string
  conversationId: string
  rating?: string | null
}
export type MessageFeedbackParams = {
  /** up, down, or null / blank to clear a previous rating. */
  rating?: string | null
}
export type ActionDispatch = {
  actionId: string
  status: string
}
export type ArtifactLink = {
  url: string
  filename: string
  expiresAt: string
}
export type DashboardRefreshEvent = {
  /** Event type, for example `panel`. */
  type: string
}
export type DashboardRefreshParams = {
  tiles: {
    [key: string]: unknown
  }[]
}
export type DashboardSave = {
  id: string
  title: string
  spec: {
    [key: string]: unknown
  }
  createdAt: string
  updatedAt: string
}
export type DashboardSaveCreateParams = {
  title: string
  /** The dashboard as the UI renders it, e.g. `{ panels: [...], order: [...] }`. */
  spec?: {
    [key: string]: unknown
  } | null
}
export type CursorPagedListDashboardSave = {
  data: DashboardSave[]
  links: CursorLinks
  meta: CursorMeta
}
export const {
  useCreateConversationMutation,
  useListConversationsQuery,
  useLazyListConversationsQuery,
  useGetConversationQuery,
  useLazyGetConversationQuery,
  useUpdateConversationMutation,
  useDeleteConversationMutation,
  useShareConversationMutation,
  useSendMessageMutation,
  useCreateAttachmentMutation,
  useSetMessageFeedbackMutation,
  useGetActionQuery,
  useLazyGetActionQuery,
  useDispatchActionMutation,
  useGetActionArtifactQuery,
  useLazyGetActionArtifactQuery,
  useGetActionArtifactLinkQuery,
  useLazyGetActionArtifactLinkQuery,
  useRejectActionMutation,
  useRefreshDashboardMutation,
  useCreateDashboardSaveMutation,
  useListDashboardSavesQuery,
  useLazyListDashboardSavesQuery,
  useGetDashboardSaveQuery,
  useLazyGetDashboardSaveQuery,
  useDeleteDashboardSaveMutation
} = injectedRtkApi
